const geleData = [
  "https://images2.imgbox.com/95/dc/ijWXfhNa_o.jpg",
  "https://images2.imgbox.com/25/e2/fFNI72TG_o.jpg",
  "https://images2.imgbox.com/c9/d5/4tFWya9f_o.jpg",
  "https://images2.imgbox.com/b8/68/R75hRNZQ_o.jpg",
  "https://images2.imgbox.com/15/87/jbGTMnhq_o.jpg",
  "https://images2.imgbox.com/ce/80/af9UHWnd_o.jpg",
  "https://images2.imgbox.com/9a/28/Ovire3CZ_o.jpg",
  "https://images2.imgbox.com/5c/2d/UDYIZVxY_o.jpg",
  "https://images2.imgbox.com/86/06/FWYQ3VvL_o.jpg",
  "https://images2.imgbox.com/4f/3e/2b3K1yhb_o.jpg",
  "https://images2.imgbox.com/5d/44/SBA2EHKX_o.jpg",
  "https://images2.imgbox.com/64/18/LHoPsrzi_o.jpg",
  "https://images2.imgbox.com/5e/6f/4RdouZ6n_o.jpg",
  "https://images2.imgbox.com/1b/96/BgTRdhK5_o.jpg",
  "https://images2.imgbox.com/2e/44/OC8EGEk8_o.jpg",
  "https://images2.imgbox.com/ce/6b/7nyjRFiK_o.jpg",
  "https://images2.imgbox.com/3f/11/pKeC81Ib_o.jpg",
  "https://images2.imgbox.com/6f/ee/uWxbYoBP_o.jpg",
  "https://images2.imgbox.com/75/c7/nyWRvZDu_o.jpg",
  "https://images2.imgbox.com/5a/9b/7B4KbUyr_o.jpg",
  "https://images2.imgbox.com/c4/12/x9lxyE9z_o.jpg",
  "https://images2.imgbox.com/e0/8c/aGw0nFLt_o.jpg",
  "https://images2.imgbox.com/f0/38/VkVCSHA0_o.jpg"
];

const gelebw = [
  "https://images2.imgbox.com/49/93/8UJgbtCB_o.jpg",
  "https://images2.imgbox.com/2e/bd/tWEElsyX_o.jpg",
  "https://images2.imgbox.com/ba/6f/aKoPwFMM_o.jpg",
  "https://images2.imgbox.com/47/5e/8c4d97GU_o.jpg",
  "https://images2.imgbox.com/7b/13/usq3e9Dj_o.jpg",
  "https://images2.imgbox.com/d8/d0/VLlQjYXh_o.jpg",
  "https://images2.imgbox.com/ee/62/DMWvkL6u_o.jpg",
  "https://images2.imgbox.com/78/b2/CHrNT1wd_o.jpg",
  "https://images2.imgbox.com/f3/17/jsTxvUkL_o.jpg",
  "https://images2.imgbox.com/7e/55/CsvvllYU_o.jpg",
  "https://images2.imgbox.com/14/bd/VNAv1dsH_o.jpg",
  "https://images2.imgbox.com/2b/e3/Z1lXhNs2_o.jpg",
  "https://images2.imgbox.com/84/d3/tZebkvsa_o.jpg",
  "https://images2.imgbox.com/d1/eb/A3zb7wkh_o.jpg",
  "https://images2.imgbox.com/38/e9/rm2HTdX7_o.jpg",
  "https://images2.imgbox.com/e0/5f/boiNGJ3k_o.jpg",
  "https://images2.imgbox.com/82/01/am1g2NA4_o.jpg",
  "https://images2.imgbox.com/d3/e7/Nmmjdl9u_o.jpg",
  "https://images2.imgbox.com/90/4b/H3AKU0ZQ_o.jpg",
  "https://images2.imgbox.com/45/8b/ZONfwhjD_o.jpg",
  "https://images2.imgbox.com/9c/e8/l3mcxfXm_o.jpg",
  "https://images2.imgbox.com/c9/05/MOVDBvo0_o.jpg",
  "https://images2.imgbox.com/fb/c8/7FvmCfaz_o.jpg"
];

export const dataObj = [...geleData].map((item, index) => ({
  src: item,
  srcbw: gelebw[index]
}));

export const imgSlide = {
  slide1:
    "https://dl.dropboxusercontent.com/scl/fi/ext810lfqa8uiqsag9tbx/slide1min.jpg?rlkey=w0piked76wepkaxuzoekvrmqp&dl=0",
  slide2:
    "https://dl.dropboxusercontent.com/scl/fi/oanu2l9blqn8suy222ff8/slide2min.jpg?rlkey=ifip1l8uljtxc4xy4g7qevdxg&dl=0",
  slide3:
    "https://dl.dropboxusercontent.com/scl/fi/8969t4fac8m6sagf92p1q/slide3min.jpg?rlkey=su5una32rog66jsrzcd740cez&dl=0"
};
